export default function useScrollTo() {
  const scrollToElement = (element: HTMLElement, offset: number): void => {
    const y: number =
      element.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  const scrollTo = (id: string): void => {
    const element: HTMLElement | null = document.querySelector(`#${id}`);

    if (element instanceof HTMLElement) {
      scrollToElement(element, -25);
    }
  };

  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToFirstBlock = (): void => {
    const element: HTMLElement | null = document.querySelector(
      '.slide-container .form-block',
    );

    if (element instanceof HTMLElement) {
      scrollToElement(element, -25);
    } else {
      scrollToTop();
    }
  };

  return {
    scrollTo,
    scrollToTop,
    scrollToElement,
    scrollToFirstBlock,
  };
}
